import { render, staticRenderFns } from "./BasicInformation.vue?vue&type=template&id=248e9d3a&scoped=true&"
import script from "./BasicInformation.vue?vue&type=script&lang=js&"
export * from "./BasicInformation.vue?vue&type=script&lang=js&"
import style0 from "./BasicInformation.vue?vue&type=style&index=0&id=248e9d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "248e9d3a",
  null
  
)

export default component.exports